import { roleChangeRequest } from '../actions/constants';

const initState = {
  roleChangeRequests: [],
  officeRequests: [],
  hasIncompleteStatus: false,
  loading: false,
  officeRequestsLoading: false,
  updating: false,
  message: '',
  error: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case roleChangeRequest.CREATE_ROLE_CHANGE_REQUEST:
    case roleChangeRequest.GET_ROLE_CHANGE_BY_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case roleChangeRequest.CREATE_ROLE_CHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload?.message || '',
      };

    case roleChangeRequest.CREATE_ROLE_CHANGE_FAILURE:
    case roleChangeRequest.GET_ROLE_CHANGE_BY_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload?.message || action.payload?.error || 'Ошибка',
      };

    case roleChangeRequest.GET_ROLE_CHANGE_BY_USER_SUCCESS:
      return {
        ...state,
        roleChangeRequests: action.payload?.roleChangeRequests || [],
        hasIncompleteStatus: !!action.payload?.hasIncompleteStatus,
        loading: false,
        error: null,
      };

    case roleChangeRequest.GET_OFFICE_ROLE_CHANGE_REQUESTS_REQUEST:
      return {
        ...state,
        officeRequestsLoading: true,
        error: null,
      };

    case roleChangeRequest.GET_OFFICE_ROLE_CHANGE_REQUESTS_SUCCESS:
      return {
        ...state,
        officeRequestsLoading: false,
        officeRequests: action.payload?.items || [],
        error: null,
      };

    case roleChangeRequest.GET_OFFICE_ROLE_CHANGE_REQUESTS_FAILURE:
      return {
        ...state,
        officeRequestsLoading: false,
        error: action.payload?.message || action.payload?.error || 'Ошибка',
      };

    case roleChangeRequest.UPDATE_ROLE_CHANGE_STATUS_REQUEST:
    case roleChangeRequest.UPDATE_ROLE_CHANGE_VIEWED_REQUEST:
    case roleChangeRequest.DELETE_ROLE_CHANGE_REQUEST:
      return {
        ...state,
        updating: true,
        error: null,
      };

    case roleChangeRequest.UPDATE_ROLE_CHANGE_STATUS_SUCCESS:
    case roleChangeRequest.UPDATE_ROLE_CHANGE_VIEWED_SUCCESS:
    case roleChangeRequest.DELETE_ROLE_CHANGE_SUCCESS:
      return {
        ...state,
        updating: false,
        message: action.payload?.message || '',
      };

    case roleChangeRequest.UPDATE_ROLE_CHANGE_STATUS_FAILURE:
    case roleChangeRequest.UPDATE_ROLE_CHANGE_VIEWED_FAILURE:
    case roleChangeRequest.DELETE_ROLE_CHANGE_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload?.message || action.payload?.error || 'Ошибка',
      };

    default:
      return state;
  }
};